<template>
  <div :class="_.actions">
    <button
      v-if="item.status === 900 || item.status === 901 || item.status === 902"
      v-track="{
        name: '我的订单-操作栏-删除订单',
        id: '2b58cca6-82a6-4e9b-b110-0681bb5c482b',
        content: orderNo,
      }"
      @click="handleDeleteClick"
    >
      删除订单
    </button>
    <button
      v-if="item.status === 0"
      v-track="{
        name: '我的订单-操作栏-取消订单',
        id: '58be3cff-a209-4228-9b27-5478e9317c09',
        content: orderNo,
      }"
      @click="handleCancelClick"
    >
      取消订单
    </button>
    <button
      v-if="item.status === 0"
      v-track="{
        name: '我的订单-操作栏-立即支付',
        id: 'e7b63a5e-4e23-4580-9695-b37247ea898a',
        content: orderNo,
      }"
      :class="_.red"
      @click="handlePayClick"
    >
      立即支付
    </button>
    <button
      v-if="
        (item.status === 100 || item.status === 102) && item.urgedStatus !== -1
      "
      v-track="{
        name: '我的订单-操作栏-提醒发货',
        id: '24f1fb1d-866a-473b-9530-ea1cd34dcbb1',
        content: orderNo,
      }"
      @click="handleRemindClick"
    >
      提醒发货
    </button>
    <button
      v-if="item.status === 101 && item.delayStatus !== -1"
      v-track="{
        name: '我的订单-操作栏-延长收货',
        id: '66c86cd6-3d1a-4b1b-a978-7315940418a2',
        content: orderNo,
      }"
      @click="handleDelayClick"
    >
      延长收货
    </button>
    <button
      v-if="item.status === 101 || item.status === 102"
      v-track="{
        name: '我的订单-操作栏-查看物流',
        id: '59a9c406-ce75-4d11-83a0-86237f9d45db',
        content: orderNo,
      }"
      @click="handleExpressClick"
    >
      查看物流
    </button>
    <button
      v-if="item.status === 101"
      v-track="{
        name: '我的订单-操作栏-确认收货',
        id: '193aee3f-e968-411c-bac7-2695f6f0eda6',
        content: orderNo,
      }"
      :class="_.red"
      @click="handleConfirmClick"
    >
      确认收货
    </button>
    <button
      v-if="
        (item.status === 900 || item.status === 902) &&
        item.evaluationStatus === 0
      "
      v-track="{
        name: '我的订单-操作栏-评价',
        id: 'bbc5e3ee-9f9c-421c-b3c8-149d246ff5e1',
        content: orderNo,
      }"
      @click="handleCommentClick"
    >
      评价
    </button>
    <button
      v-if="
        (item.status === 900 || item.status === 902) &&
        item.evaluationStatus === 1
      "
      v-track="{
        name: '我的订单-操作栏-追加评价',
        id: '7d437b18-e6c8-4bb0-8bda-8943db164853',
        content: orderNo,
      }"
      @click="handleCommentAgainClick"
    >
      追加评价
    </button>
  </div>
</template>

<script>
  import {
    apiOrderOrderCancel,
    apiOrderOrderConfirm,
    apiOrderOrderDelayConfirm,
    apiOrderOrderDelete,
    apiOrderOrderPay,
    apiOrderOrderUrged,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { Dialog } from 'vant'
  import { globalModel } from '@/model'
  import { navigateTo } from '@/router'
  import { submit } from '@/utils'

  export default {
    props: {
      // 条目
      item: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      hasChildren: true,
    }),

    computed: {
      // 订单号
      orderNo() {
        return this.item.orderNo
      },
    },

    mounted() {
      this._classNames = this.$el.className
      if (!this.$el.children.length) {
        this.$el.className = this._.hidden
      }
    },

    updated() {
      this.$el.className = !this.$el.children.length
        ? this._.hidden
        : this._classNames
    },

    methods: {
      // 点击取消订单
      async handleCancelClick() {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定取消此订单吗？',
          })
          await $.start()
          await apiOrderOrderCancel({
            orderNo: this.orderNo,
          })
          this.$emit('refresh')
          navigateTo('OrderCancelResult')
        })
      },

      // 点击支付
      async handlePayClick() {
        await submit(async $ => {
          await $.start()
          const payData = await apiOrderOrderPay({
            orderNo: this.orderNo,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
          })
          await dcb.requestPayment({
            provider: 'native',
            showNativeResultPage: false,
            params: payData,
          })
          this.$emit('refresh')
          await $.success('支付成功')
        })
      },

      // 点击查看物流
      handleExpressClick() {
        navigateTo('ExpressIndex', {
          orderNo: this.orderNo,
        })
      },

      // 点击确认收货
      async handleConfirmClick() {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确认已经收到货物了吗？',
            cancelButtonText: '暂未',
            confirmButtonText: '确认收到',
          })
          await $.start()
          await apiOrderOrderConfirm({
            orderNo: this.orderNo,
          })
          this.$emit('refresh')
          navigateTo('OrderConfirmResult', {
            orderNo: this.orderNo,
          })
        })
      },

      // 点击延长收货
      async handleDelayClick() {
        await submit(async $ => {
          await apiOrderOrderDelayConfirm({
            orderNo: this.orderNo,
          })
          this.$emit('refresh')
          await $.success('延长收货成功')
        })
      },

      // 点击提醒发货
      async handleRemindClick() {
        await submit(async $ => {
          await $.start()
          await apiOrderOrderUrged({
            orderNo: this.orderNo,
          })
          this.$emit('refresh')
          await $.success('提醒发货成功')
        })
      },

      // 点击删除订单
      async handleDeleteClick() {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定删除此订单吗？',
          })
          await $.start()
          await apiOrderOrderDelete({
            orderNo: this.orderNo,
          })
          this.$emit('refresh', {
            trigger: 'delete',
          })
          await $.success('删除成功')
        })
      },

      // 点击评价
      handleCommentClick() {
        navigateTo('OrderComment', {
          orderNo: this.orderNo,
        })
      },

      // 点击追加评价
      handleCommentAgainClick() {
        navigateTo('OrderComment', {
          orderNo: this.orderNo,
        })
      },
    },
  }
</script>

<style lang="scss" module>
  .actions {
    text-align: right;
    font-size: 0;

    button {
      border-radius: 17px;
      border: 1px solid rgba(190, 190, 190, 0.93);
      background-color: transparent;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      padding: 5px 15px;
      margin-left: 12px;

      &.red {
        color: #ffffff;
        background: #ff111c;
        border: 1px solid #ff111c;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .hidden {
    display: none;
  }
</style>
